<!-- side button: only when the patient has an earlier exam of this clinic type -->
<div class="clinic-prev-bar" *ngIf="previous && !es.isClosed">
  <span class="clinic-prev-error" *ngIf="failed">{{ 'clinicPrev.failed' | translate }}</span>
  <button type="button" class="blue-btn" [disabled]="copying" (click)="askPull()">
    {{ 'clinicPrev.pull' | translate }}
  </button>
</div>

<!-- first open of a new exam: offer to pull -->
<div *ngIf="showPrompt" class="t-popup popup-patientDetails popup-centered">
  <div class="t-popup-frame">
    <div class="t-popup-body">
      <h2 class="clinic-prev-msg">
        {{ 'clinicPrev.promptMsg' | translate: { date: (previous?.creationTime | date: 'dd/MM/yyyy') } }}
      </h2>
      <div class="clinic-prev-actions">
        <button type="button" class="blue-btn" (click)="promptYes()">{{ 'clinicPrev.yes' | translate }}</button>
        <button type="button" class="orange-btn" (click)="promptNo()">{{ 'clinicPrev.no' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!-- from the side button: pulling replaces what is written in this exam -->
<div *ngIf="showConfirm" class="t-popup popup-patientDetails popup-centered">
  <div class="t-popup-frame">
    <div class="t-popup-body">
      <h2 class="clinic-prev-msg">{{ 'clinicPrev.overwriteMsg' | translate }}</h2>
      <div class="clinic-prev-actions">
        <button type="button" class="blue-btn" (click)="confirmYes()">{{ 'clinicPrev.yes' | translate }}</button>
        <button type="button" class="orange-btn" (click)="confirmNo()">{{ 'clinicPrev.no' | translate }}</button>
      </div>
    </div>
  </div>
</div>
